var site = site || {};
var generic = generic || {};
var Drupal = Drupal || {};
var Model = Model || {};

site.prodStoreCheck = site.prodStoreCheck || {};

(function ($) {
  /**
    * In-store locator class that handles the interfacing with the product pages.
    * Uses the in-store library classes to handle map and door calls along with the display.
    * Also handles common functionality used in different panels, like the location overlay.
    * Class needs to be loaded on page load using the event 'instore:product:init'.
    * When the locator is needed, you can display inline or in an overlay using the events
    *   'instore:product:overlay' or 'instore:product:inline'.
    * Event bindings placed in the bindEvents method are also available once it is instantiated.
  */
  site.inStoreLocator = function () {
    this.dom = {};
    this.bodyClass = 'product-store-check';
    this.eventNameSpace = 'inStoreLocator:';
    this.$container = '';
    this.$cartBtn = '';
    this.timer = '';
  };

  /**
    * Class to set up various in-store locator css state classes.
    * Look to the site's css as reference.
  */
  site.inStoreLocator.prototype.states = {
    doorsShown: 'state-doors-shown',
    doorsShownInline: 'state-doors-shown-inline'
  };

  /**
    * Method to instantiate different classes variables when inStoreLocator is loaded.
    * Mainly used to make data is cleared out if locator is opened more than once.
  */
  site.inStoreLocator.prototype.setVars = function (args) {
    var _args = args || {};

    this.dom.$inlineContainer = null;
    this.resultData = {};
    this.mergedDoorData = {};
    this.activeSku = _args.activeSku || null;
    this.containerOpen = true;
    this.isMobile = false;
    this.state = '';
    this.loaded = false;
    this.disableAPI = false;
    this.isAutoGeo = '';
  };

  /**
    * Method to get all DOM selectors when class is initialized.
    * All selectors should be placed here to keep everything located in one spot.
  */
  site.inStoreLocator.prototype.getNodes = function () {
    this.dom.$inStoreContainerInline = $('.js-store-check-inline');
    this.dom.$inStoreContainerOverlay = $('.js-store-check-overlay');
    this.dom.$doorsContainer = $('.js-product-doors');
    this.dom.$locConfirmOverlay = $('.js-location-confirm');
    this.dom.$locConfirmAcceptBtn = $('.js-location-allow');
    this.dom.$locConfirmDeclineBtn = $('.js-location-decline');
    this.dom.$locConfirmCloseBtn = $('.js-location-confirm-close');
    this.dom.$defaultSearchDistInput = $('.js-default-search-distance');
    this.dom.$miscFlagsInput = $('.js-misc-flags');
    this.dom.$regionIdsInput = $('.js-region-ids');
    this.dom.$storeTypeInput = $('.js-store-types');
    this.dom.$unitOfMeasurement = $('.js-unit-of-measurement');
    this.dom.$storeTypeClassification = $('.js-store-types-classification');
    this.dom.$closeLink = $('.close-link');
  };

  /**
    * Method to set all bind events when class is initialized.
    * All bind events, including events from other panels, should be placed here.
  */
  site.inStoreLocator.prototype.bindEvents = function () {
    $(document).on(this.eventNameSpace + 'addDoorsState', $.proxy(this.addDoorsState, this));
    $(document).on(this.eventNameSpace + 'addDoorsStateInline', $.proxy(this.addDoorsStateInline, this));
    $(document).on(this.eventNameSpace + 'reset', $.proxy(this.onReset, this));
    $(document).on(this.eventNameSpace + 'inserted', $.proxy(this.checkAreaDoors, this));
    $(document).on(this.eventNameSpace + 'layout:init', $.proxy(this.initLayout, this));
    $(document).on(this.eventNameSpace + 'removeEvents', $.proxy(this.removeEvents, this));
    $(document).on(this.eventNameSpace + 'state:set', $.proxy(this.setStateClass, this));

    $(document).on('MPP:quickshopsDestroyed', $.proxy(this.onReset, this));
  };

  /**
    * Method to handle the display of the inventory locator button.
    * Checks the product data to see if it follows the display criteria set in the CMS.
    * If it passes, it will then check to see if doors are in the area.
    * If so, it will load the API and set buttons events defined in setButtonEvents.
  */
  site.inStoreLocator.prototype.setDisplay = function (e, args) {
    var that = this;
    var _args = args || {};

    that.$container = this.container || _args.$container;
    that.$cartBtn = this.cartButton || _args.$cartBtn;

    if (!that.$container || !that.$cartBtn) {
      return null;
    }

    _args.prodData = _args.data || Model.PageData.get();
    var selectedSku;
    var activeSkuArgs;

    if (Drupal.settings.common && Drupal.settings.common.disable_auto_spoofing) {
      selectedSku = $('.js-sku-price');
      if (selectedSku.length) {
        selectedSku = selectedSku.attr('data-sku-id').slice(3);
        activeSkuArgs = _args.activeSku || selectedSku || that.$cartBtn.attr('data-sku-base-id');
      }
    } else {
      activeSkuArgs = _args.activeSku || that.$cartBtn.attr('data-sku-base-id');
    }

    $(document).trigger('instore:product:inline', {
      prodData: _args.prodData,
      container: that.$container,
      activeSku: activeSkuArgs
    });
  };

  /**
    * Convience method to compare a product's MISC_FLAG to the MISC_FLAG set in the CMS.
    * The CMS adds the MISC_FLAGs to hide in the module array site.prodStoreCheck.hideBtnMiscFlags.
    * If the MISC_FLAG of the product matches any of the flags in the array, it will fail.
  */
  site.inStoreLocator.prototype.checkProdFlags = function (data) {
    if (!data) {
      return true;
    }
    var isValid = true;

    if (this.dom.$miscFlagsInput.length) {
      var miscFlagVals = this.dom.$miscFlagsInput.val();
      var flagsArray = miscFlagVals.split(',');

      for (var x = 0; x < flagsArray.length; x++) {
        if (data.MISC_FLAG.toString() === flagsArray[x].toString()) {
          isValid = false;
        }
      }
    }

    return isValid;
  };

  /**
    * Method to load all supporting libraries for the in-store locator.
    * Called before in-store locator is displayed.
  */
  site.inStoreLocator.prototype.init = function () {
    // Load supporting library files.

    this.Controls = new site.controls();
    this.Display = new site.display();
    this.Doors = new site.doors();
  };

  /**
    * Method to display in-store locator in the page document.
    * After all methods are called, the 'inStoreLocator:opened' event is triggered.
  */
  site.inStoreLocator.prototype.inline = function (e, args) {
    var _args = args || {};

    this.init();
    this.setVars(_args);
    this.setMobileFlag();
    this.bindEvents();
    this.insert(_args);
    this.handleIPadOrientationChange(_args);
  };

  /**
    * Method to insert the in-store template to the pass $container DOM selector.
    * Used for the inline option of the in-store locator.
  */
  site.inStoreLocator.prototype.insert = function (args) {
    var _args = args || {};
    var that = this;

    if (site.templates && site.templates['product_store_check_layout']) {
      site.template.get({
        name: 'product_store_check_layout',
        data: {},
        callback: function (html) {
          // Need to filter out no visible container since mobile and pc templates are used together.
          that.dom.$inlineContainer = _args.container.filter(function () {
            return $(this).is(':visible');
          });
          that.dom.$inlineContainer.html(html);

          that.getNodes();
          var isValidProd = that.checkProdFlags(_args.prodData);

          if (isValidProd) {
            $(document).trigger(that.eventNameSpace + 'inserted', _args);
          }
        }
      });
    }
  };

  /**
    * Method to handle the display switching for iPad.
    * Since this site displays mobile view in portrait and destop in landscape, this was a solution.
    * The inv vis load template lives in two places and this switches between the two.
    */
  site.inStoreLocator.prototype.handleIPadOrientationChange = function () {
    if (this.isMobile) {
      return null;
    }

    var $cont = '';
    var $deskTopCont = $('.js-instore-inv-container', '.mobile-hidden');
    var $mobileCont = $('.js-instore-inv-container', '.pc-hidden');
    var swapContainers = function () {
      if (window.orientation === 0 || window.orientation === 180) {
        // Landscape views
        $cont = $('.js-instore-container', $deskTopCont).detach();
        $($cont[0]).appendTo($mobileCont[0]);
      } else {
        // Portrait views
        $cont = $('.js-instore-container', $mobileCont).detach();
        $($cont[0]).appendTo($deskTopCont[0]);
      }
    };

    window.onorientationchange = function () {
      swapContainers();
    };
  };

  /**
    * Method to close in-store locator in the page document.
    * Fires the panel close event which can also be used by other panels.
  */
  site.inStoreLocator.prototype.close = function (e, args) {
    $(document).trigger(this.eventNameSpace + 'close');
  };

  /**
    * Method to close in-store locator in the page document.
    * Fires the panel close event which can also be used by other panels.
  */
  site.inStoreLocator.prototype.closeInline = function (e, args) {
    $(document).trigger(this.eventNameSpace + 'close');
    if (this.dom && this.dom.$inlineContainer) {
      this.dom.$inlineContainer.html('');
    }
  };

  /**
    * Method to initialize the inserted the in-store template.
    * Used for the inline option of the in-store locator.
  */
  site.inStoreLocator.prototype.initLayout = function (e, args) {
    var _args = args || {};

    this.loaded = true;

    this.getNodes();
    this.addBodyClass();

    $(document).trigger('instore:product:queue:check');

    $(document).trigger(this.eventNameSpace + 'opened', _args);
  };

  /**
  * Method that checks if there are any doors in your area.
  * It uses Model.DoorsInventory.loadDoorsOnly to do a door only query.
  * If results are returned, it will trigger layout:init; otherwise, just clear the container node.
  */
  site.inStoreLocator.prototype.checkAreaDoors = function (e, args) {
    if (!Model.DoorsInventory) {
      return null;
    }
    var that = this;
    var _args = args || {};
    var hasDoorsInArea = false;
    var _skus = null;
    var prodData = _args.prodData || null;

    if (prodData) {
      var prodSkus = prodData.skus ? prodData.skus : [];

      _skus = prodSkus.length ? prodSkus[0].SKU_BASE_ID : null;
    }

    var defaultDistanace = that.dom.$defaultSearchDistInput.val();
    var regionId = that.dom.$regionIdsInput.val();
    var storeTypes = that.dom.$storeTypeInput.val();
    var unitOfMeasurement = that.dom.$unitOfMeasurement.val();
    var storeTypesClassification = that.dom.$storeTypeClassification.val();
    var $findInBtn = $('.js-find-in-store');

    if (Drupal.settings.common && Drupal.settings.common.disable_auto_spoofing) {
      that.isAutoGeo = site.templates['product_store_check_layout'] && site.templates['product_store_check_layout'].data.enable_autogeo_onload;
      if (that.isAutoGeo) {
        $findInBtn.removeClass('hidden');
      } else {
        $findInBtn.addClass('hidden');
        $(document).trigger('display:inline:edit', _args);
      }
      _args.enableZip = that.isAutoGeo ? '' : true;
      that.disableAPI = true;
      $findInBtn.once().click(function (e) {
        e.preventDefault();
        _args.disableOverlay = true;
        Model.DoorsInventory.load({
          skus: _args.activeSku || _skus,
          radius: defaultDistanace,
          region_id: regionId,
          // inv_store_types : storeTypes,
          uom: unitOfMeasurement,
          useHeader: that.isAutoGeo ? true : '',
          disable_api: that.disableAPI,
          inv_store_classification: storeTypesClassification, // Aveda uses CLASSIFICATION for filter instead of STORE_TYPE
          callback: function () {
            $(document).trigger(that.eventNameSpace + 'layout:init', _args);
          }
        });
      });
    } else {
      Model.DoorsInventory.load({
        skus: _args.activeSku || _skus,
        radius: defaultDistanace,
        region_id: regionId,
        // inv_store_types : storeTypes,
        uom: unitOfMeasurement,
        useHeader: true,
        inv_store_classification: storeTypesClassification, // Aveda uses CLASSIFICATION for filter instead of STORE_TYPE
        callback: function () {
          $(document).trigger(that.eventNameSpace + 'layout:init', _args);
        }
      });
    }
  };

  /**
    * Method that handles controlling the sku changes for a multi sku product.
    * Race conditions happen when the sku changes too quickly.
    * So a buffer is added to make sure the UI can catch up with the current sku selected.
  */
  site.inStoreLocator.prototype.setUserTimer = function (skuId) {
    var that = this;

    if (that.timer) {
      window.clearTimeout(that.timer);
    }
    that.timer = window.setTimeout(function () {
      $(document).trigger('instore:loaded', skuId);
    }, 750);
  };

  /**
    * Method that handles changes when the product sku select is changed in another panel class.
    * When the sku is changed, it triggers the removal of all module events.
    * It then triggers setUserTimer to set up the timing buffer per each change.
  */
  site.inStoreLocator.prototype.onSkuChange = function (e, skuId) {
    if (this.loaded) {
      if (Model.DoorsInventory) {
        Model.DoorsInventory.remove();
      }
      $(document).trigger(this.eventNameSpace + 'reset');
      this.setUserTimer(skuId);
    }
  };

  /**
    * Method to handle all close events for the in-store locator.
    * Will be called if the event 'inStoreLocator:close' is fired.
  */
  site.inStoreLocator.prototype.onReset = function () {
    this.containerOpen = false;
    this.removeBodyClass();
    this.removeEvents();
  };

  /**
    * Method to unbind all events associated to document.
    * This will iterate through all docuemnt events removing all events with the panel event name space.
    * Defaults to the current evenetNameSpace but you can pass other namespaces in other panels too.
  */
  site.inStoreLocator.prototype.removeEvents = function (e, args) {
    var _args = args || {};
    var nameSpace = _args.nameSpace ? _args.nameSpace : this.eventNameSpace;
    var docEvents = $._data($(document)[0], 'events');

    for (var evt in docEvents) {
      var match = evt.match('^' + nameSpace);

      if (match) {
        $(document).unbind(match.input);
      }
    }
  };

  /**
    * Method to handle adding the doorsShown state to the inline in-store locator.
    * Similar to addDoorsState, but uses a class specific to having the locator be inline.
    * Also can be used with the even't 'inStoreLocator:addDoorsStateInline'.
  */
  site.inStoreLocator.prototype.addDoorsStateInline = function () {
    this.dom.$inStoreContainerInline.addClass(this.states.doorsShownInline);
  };

  /**
    * Method to add the defined locator body class to the DOM.
    * Used if any css styling is needed outside of the locator.
  */
  site.inStoreLocator.prototype.addBodyClass = function () {
    $('body').addClass(this.bodyClass);
  };

  site.inStoreLocator.prototype.setStateClass = function (e, args) {
    var _args = args || {};
    var prefix = 'psc-state-';
    var regEx = new RegExp(prefix + '[\\w]*', 'g');
    var $cont = _args.setOverlay ? this.dom.$inStoreContainerOverlay : this.dom.$inStoreContainerInline;

    if ($cont.length) {
      var containerClass = $cont.attr('class');
      var hasStateClass = containerClass.match(regEx);

      if (hasStateClass) {
        $cont.removeClass(hasStateClass[0]);
      }
      $cont.addClass(prefix + _args.state);
    }
  };

  /**
    * Method to remove the defined locator body class to the DOM.
  */
  site.inStoreLocator.prototype.removeBodyClass = function () {
    $('body').removeClass(this.bodyClass);
  };

  site.inStoreLocator.prototype.setMobileFlag = function () {
    if ($('body').hasClass('device-mobile')) {
      this.isMobile = true;
      $(document).trigger(this.eventNameSpace + 'device:set', this.isMobile);
    }
  };

  /**
    * Method to define the event triggers that are used by the product pages to display the locator.
    * Used on page load and when the module is destroyed.
  */
  site.inStoreLocator.prototype.load = function () {
    $(document).on('instore:product:setDisplay', $.proxy(Drupal.behaviors.inStoreLocator.setDisplay, this));
    $(document).on('instore:product:loadApi', $.proxy(Drupal.behaviors.inStoreLocator.loadApi, Drupal.behaviors.inStoreLocator));
    $(document).on('instore:product:inline', $.proxy(Drupal.behaviors.inStoreLocator.inline, Drupal.behaviors.inStoreLocator));
    $(document).on('instore:product:close', $.proxy(Drupal.behaviors.inStoreLocator.close, Drupal.behaviors.inStoreLocator));
    $(document).on('instore:product:closeInline', $.proxy(Drupal.behaviors.inStoreLocator.closeInline, Drupal.behaviors.inStoreLocator));
    $(document).on('instore:product:checkAreaDoors', $.proxy(Drupal.behaviors.inStoreLocator.checkAreaDoors, Drupal.behaviors.inStoreLocator));
    $(document).on('product.skuSelect', $.proxy(Drupal.behaviors.inStoreLocator.onSkuChange, Drupal.behaviors.inStoreLocator));
    $(document).trigger('instore:loaded');
  };

  /**
    * Returns the event that will triggr the store locator initialization on product init.
  */
  site.inStoreLocator.prototype.getTriggerEvent = function () {
    return 'product.init';
  };

  /**
    * Instantiation of the Drupal inStoreLocator.
  */
  Drupal.behaviors.inStoreLocator = new site.inStoreLocator();

  /**
    * Initialize the store locator.
    * Makes sure this is only loaded once.
  */
  $(document).on(Drupal.behaviors.inStoreLocator.getTriggerEvent(), function () {
    if (this.loaded) {
      return null;
    }
    this.loaded = true;
    Drupal.behaviors.inStoreLocator.load();
  });
})(jQuery);
